var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 5,
    fill: "#E8E2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 34V16C18 15.73 18 15.45 18.07 15.18C18.1312 14.9106 18.2667 14.6638 18.4612 14.4676C18.6556 14.2714 18.9012 14.1336 19.17 14.07C19.46 14 20.73 14 21 14H28C28.27 14 28.55 14 28.82 14.07C29.0894 14.1312 29.3362 14.2667 29.5324 14.4612C29.7286 14.6556 29.8664 14.9012 29.93 15.17C30 15.45 30 15.73 30 16V34H18Z",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26V32C14 33.1 14.9 34 16 34H18V24H16C15.73 24 15.45 24 15.18 24.07C14.91 24.14 14.66 24.27 14.46 24.47C14.27 24.66 14.14 24.91 14.07 25.18C14.0136 25.4495 13.9901 25.7248 14 26Z",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.82 21.0698C32.5505 21.0133 32.2752 20.9898 32 20.9998H30V33.9998H32C32.5304 33.9998 33.0391 33.7891 33.4142 33.414C33.7893 33.0389 34 32.5302 34 31.9998V22.9998C34 22.7198 34 22.4498 33.93 22.1798C33.86 21.9098 33.73 21.6598 33.53 21.4598C33.34 21.2698 33.09 21.1398 32.82 21.0698Z",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H26",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H26",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26H26",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H26",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeIcon);
export default __webpack_public_path__ + "static/media/office_icon.fb0912e2194a8ecacaaa0e29b49eb641.svg";
export { ForwardRef as ReactComponent };